<template>
  <div class="mobile-nav">
    <!-- 汉堡菜单按钮 -->
    <van-icon
      name="wap-nav"
      size="24"
      class="hamburger"
      @click="showNav = true"
    />

    <!-- 侧边导航 -->
    <van-popup
      v-model="showNav"
      position="left"
      :style="{ width: '70%', height: '100%' }"
      class="nav-popup"
    >
      <div class="nav-header">
        <img :src="logoUrl" alt="logo" class="nav-logo" />
        <van-icon name="cross" size="20" @click="showNav = false" />
      </div>

      <div class="nav-user" v-if="userInfo.token">
        <span>欢迎，{{ userInfo.name || '用户' }}</span>
      </div>
      <div class="nav-user" v-else>
        <span>未登录</span>
      </div>

      <van-cell-group>
        <van-cell title="首页" icon="home-o" to="/home" @click="showNav = false" />
        <van-cell title="API列表" icon="orders-o" to="/apiMarget" @click="showNav = false" />
        <van-cell title="图书资源包下载" icon="down" to="/resourceDownload" @click="showNav = false" />
        <van-cell icon="description" to="/bookMatch" @click="showNav = false">
          <template slot="title">
            <span>批量匹配</span><span class="mobile-new-badge">新</span>
          </template>
        </van-cell>
        <van-cell title="我的匹配任务" icon="todo-list-o" to="/myBookMatch" @click="showNav = false" v-if="userInfo.token" />
        <van-cell title="个人中心" icon="user-o" to="/userLayout" @click="showNav = false" v-if="userInfo.token" />
      </van-cell-group>

      <div class="nav-footer">
        <template v-if="!userInfo.token">
          <van-button type="primary" size="small" @click="goLogin">登录</van-button>
          <van-button size="small" @click="goReg">注册</van-button>
        </template>
        <van-button v-else type="danger" size="small" @click="handleLogout">退出登录</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { logout } from '@/api/common'

export default {
  name: 'MobileNav',
  data () {
    return {
      showNav: false
    }
  },
  computed: {
    ...mapState(['logoUrl', 'userInfo'])
  },
  methods: {
    goLogin () {
      this.showNav = false
      this.$router.push('/login')
    },
    goReg () {
      this.showNav = false
      this.$router.push('/reg')
    },
    async handleLogout () {
      await logout()
      this.$store.commit('removeUserInfo')
      this.showNav = false
      this.$router.push('/').catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err
      })
    }
  }
}
</script>

<style lang="less" scoped>
.mobile-nav {
  display: none;

  .hamburger {
    color: #409EFF;
    cursor: pointer;
  }

  .nav-popup {
    background: #f7f8fa;
  }

  .nav-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    background: linear-gradient(135deg, #409EFF, #67C23A);
    color: #fff;

    .nav-logo {
      width: 100px;
      height: 38px;
      object-fit: contain;
    }
  }

  .nav-user {
    padding: 12px 16px;
    font-size: 14px;
    color: #666;
    border-bottom: 1px solid #eee;
  }

  .mobile-new-badge {
    display: inline-block;
    min-width: 20px;
    height: 18px;
    margin-left: 8px;
    padding: 0 4px;
    border-radius: 9px;
    color: #fff;
    background: linear-gradient(135deg, #ff3b30, #ff7a00);
    box-shadow: 0 2px 6px rgba(255, 59, 48, .3);
    font-size: 11px;
    font-weight: 700;
    line-height: 18px;
    text-align: center;
    vertical-align: 1px;
  }

  .nav-footer {
    position: absolute;
    bottom: 20px;
    left: 16px;
    right: 16px;
    display: flex;
    gap: 10px;

    button {
      flex: 1;
    }
  }
}

@media screen and (max-width: 768px) {
  .mobile-nav {
    display: block;
  }
}
</style>
